const MenuArea = {
    dashboard: "dashboard",
    queries: "queries",
    manage: "manage",
    pay: "pay",
    demos: "demos",
    tools: "tools"
}

export default MenuArea;